function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m143.017 393.501h-82.822v-185.197c0-4.609 3.736-8.345 8.345-8.345h66.132c4.609 0 8.345 3.736 8.345 8.345z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m296.861 393.501h-82.822v-221.703c0-4.609 3.736-8.345 8.345-8.345h66.132c4.609 0 8.345 3.736 8.345 8.345z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m450.705 393.501h-82.822v-171.892c0-4.609 3.736-8.345 8.345-8.345h66.132c4.609 0 8.345 3.736 8.345 8.345z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m495.9 452.922h-480.9c-8.284 0-15-6.716-15-15s6.716-15 15-15h480.9c8.284 0 15 6.716 15 15s-6.715 15-15 15z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m504.621 115.057c.498-6.269-3.156-13.967-11.523-15.914l-48.465-11.78c-8.053-1.963-16.162 2.982-18.118 11.032-1.957 8.05 2.982 16.162 11.032 18.118l13.708 3.332-38.858 23.979-147.336-83.88c-4.236-2.413-9.384-2.616-13.794-.543l-146.454 68.742-70.01-43.694c-7.027-4.389-16.28-2.245-20.667 4.783-4.386 7.027-2.244 16.28 4.784 20.667l76.936 48.015c4.317 2.695 9.707 3.017 14.315.854l146.805-68.907 148.31 84.435c3.859 2.024 9.238 3.073 15.299-.271l47.105-29.069-3.137 14.692c-3.452 19.543 24.213 25.093 29.338 6.266l10.398-48.694c.117-.683.162-.587.332-2.163z"
}));

function SvgSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 510.9 510.9",
    height: 512,
    viewBox: "0 0 510.9 510.9",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.4fa4275c.svg";
export { ForwardRef as ReactComponent };